<div class="accordion" id="accordionExtraction">
    <div class="card">
        <app-search-calls></app-search-calls>
        <app-search-contracts></app-search-contracts>
        <app-nb-panne-codes></app-nb-panne-codes>
        <app-service-install></app-service-install>
        <app-extraction-machines-installees></app-extraction-machines-installees>
        <app-list-install-owner></app-list-install-owner>
        <app-intervention-analysis></app-intervention-analysis>
        <app-breakdown-list></app-breakdown-list>
        <ng-container *ngIf="forAdmin"><app-check-analysis ></app-check-analysis></ng-container>
        <app-extraction-year-breakdowns></app-extraction-year-breakdowns>
        <app-extraction-breakdowns-solver></app-extraction-breakdowns-solver>
    </div>
</div>




<div class="wrapper shadowed">

</div>
